import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { PayService } from 'src/app/models/pay-service';
import { ServiceType } from 'src/app/models/service-type';
import { Unity } from 'src/app/models/unity';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ServiceService } from 'src/app/services/service.service';
import { UnityService } from 'src/app/services/unity.service';
import { getUtilitarianColumns } from 'src/app/src/utl';

@Component({
  selector: 'app-utilitarian',
  templateUrl: './utilitarian.component.html',
  styleUrls: ['./utilitarian.component.css']
})
export class UtilitarianComponent implements OnInit {

  userLog:User;

  loading:boolean = false;

  pay_services:PayService [] = [];
  pay_services_actives:PayService[] = [];
  service_types:ServiceType [] = [];
  service_types_temp:ServiceType [] = [];
  service_type:ServiceType = new ServiceType();
  type:string = 'utilitarian';

  pay_service:PayService = new PayService();
  pay_service_active:PayService = new PayService();
  unities:Unity[] = [];
  utilirian_columns:any[] = [];
  service_type_column:any[] = [];

  isMachinery:boolean = false;

  files:File[] = [];

  constructor(private authServ:AuthService, private serviceServ:ServiceService, private unityServ:UnityService, private toastr:ToastrManager, private modalService: NgbModal) { }

  ngOnInit() {
    this.userLog = this.authServ.getActualUser();
    this.isMachinery = this.authServ.isExactly('machinery') || this.authServ.isExactly('staff');
    this.search();
    this.unityServ.getFilteredUnities().then(unities=>{
      this.unities = unities.filter(uni => uni.unit_type_id == 13);
    })
  }

  search(){
    this.loading = true;
    this.serviceServ.getPayServices(this.isMachinery).subscribe(pay_services => {
      this.serviceServ.getServiceTypes().subscribe(service_types => {
        this.service_types = service_types;
        this.service_type = this.service_types[0];
        this.pay_services = pay_services.filter(pay => pay.unity.unit_type_id == 13);
        this.filterServicesTypes();
        this.loading = false;
      });
      
    },error => {
      this.toastr.errorToastr("No se pudieron recuperar los registros de pagos de los utilitarios.");
      this.loading = false;
    });
  }

  filterServicesTypes(){
    this.utilirian_columns = getUtilitarianColumns();
    this.service_type_column = [];
    this.service_types_temp = [];
    this.utilirian_columns = this.utilirian_columns.filter(colum => colum.type == this.type);
    let exist:boolean = false;
    this.utilirian_columns.forEach(uti => {
      if(this.service_type.id == uti.id){
        exist = true;
      }
    });
    if(!exist){
      this.service_type = this.service_types.find(ser => ser.id == this.utilirian_columns[0].id);
    }
    let index = this.utilirian_columns.findIndex(ser => ser.id == this.service_type.id && ser.type == this.type);//
    if(index != -1){
      this.service_type_column = this.utilirian_columns[index].columns;
      this.service_types.forEach(ser=>{
        this.utilirian_columns.forEach(uti=>{
          if(ser.id == uti.id){
            this.service_types_temp.push(ser);
          }
        });
      });
    }
    this.pay_service_active.id = 0;
    this.pay_services_actives = this.pay_services.filter(pay=> pay.service_type_id == this.service_type.id && pay.unity_id == this.pay_service.unity_id);
  }

  openModal(modal){
    this.pay_service_active = new PayService();
    this.filterServicesTypes();
    this.modalService.open(modal, { size: 'lg', centered: true });
  }

  storePayService(){
    this.loading = true;
    this.pay_service.service_type_id = this.service_type.id;
    this.serviceServ.storePayService(this.pay_service).subscribe(pay_service => {
      if(this.pay_service_active.id){
        this.pay_service_active.active = false;
        this.serviceServ.updatePayService(this.pay_service_active).subscribe(pay=>{
          this.loadFiles(pay_service);
          this.pay_service = new PayService();
          this.pay_service_active = new PayService();
          this.modalService.dismissAll();
          this.search();
        },error=>{
          console.log(error);
          this.toastr.errorToastr('No se pudo cerrar el registro del pago a sustituir.');
          this.loading = false;
        });
      }else{
        this.loadFiles(pay_service)
        this.pay_service = new PayService();
        this.modalService.dismissAll();
        this.search();
      }
    },error => {
      this.toastr.errorToastr("No se pudo crear el registro del pago de servicio.");
      this.loading = false;
    });
  }

  readFiles(files){
    this.files = files;
    console.log(this.files.length);
  }

  loadFiles(pay_service){
    this.loading = true;
    if(this.files.length == 0){
      this.loading = false;
    }else{
      let count = 0;
      for (let index = 0; index < this.files.length; index++) {
        this.serviceServ.loadFilePayService(pay_service, this.files[index]).subscribe(resp=>{
          count++;
          if(count == this.files.length){
            this.toastr.successToastr("Documento(s) cargado(s) correctamente.");
            this.files = [];
            this.loading = false;
          }
        },error=>{
          this.toastr.errorToastr("No se pudo cargar el documento " + this.files[index].name);
          this.loading = false;
        });
      }
    }
  }

  update(payService:PayService){
    this.search();
  }

}
